import { Component } from 'react';
import { VerticalSpacer } from './../core/core';
import CourseUnitsHeader from './CourseUnitsHeader';
import styles from './../SCSS/StudentProfile.module.scss';
import utilityStyles from './../SCSS/common/utilityStyles.module.scss';
import berryGraphic from '../images/berry.png';

interface KidProfileBodyProps {
  studentData: {
    studentName: string[];
    email: string;
    bookOpened: number;
    bookCompleted: number;
    berriesNum: number;
    loginTime: number;
    questFinished: number[];
    Book: string[];
    Quest: string[];
    MiniGame: string[];
    ReadAloud: string[];
    CheckIn: string[];
  };
}

interface KidProfileBodyState {
  selected: string;
  selectedUnitIndex: number;
}

class KidProfileBody extends Component<KidProfileBodyProps, KidProfileBodyState> {
  constructor(props: KidProfileBodyProps) {
    super(props);

    this.state = {
      selected: 'SEL',
      selectedUnitIndex: 0,
    };
    this.selectItem = this.selectItem.bind(this);
    this.onUnitSelect = this.onUnitSelect.bind(this);
  }

  selectItem(index: string) {
    this.setState({
      selected: index,
    });
  }

  onUnitSelect(index: number) {
    this.setState({
      selectedUnitIndex: index,
    });
  }

  render() {
    return (
      <div className={styles.KidProfileBody}>
        <div className={styles.KidHeader}>
          <div
            className={this.state.selected === 'SEL' ? `${styles.selected}` : `${styles.unSelected}`}
            onClick={() => this.selectItem('SEL')}
          >
            SEL & Books
          </div>
          <div
            className={this.state.selected === 'CCSS' ? `${styles.selected}` : `${styles.unSelected}`}
            onClick={() => this.selectItem('CCSS')}
          >
            CCSS
          </div>
          <div
            className={this.state.selected === 'Check-ins' ? `${styles.selected}` : `${styles.unSelected}`}
            onClick={() => this.selectItem('Check-ins')}
          >
            Check-ins
          </div>
          <div
            className={this.state.selected === 'Activity' ? `${styles.selected}` : `${styles.unSelected}`}
            onClick={() => this.selectItem('Activity')}
          >
            Activity
          </div>
        </div>
        {this.state.selected === 'SEL' ? (
          <div className={styles.SELStatistics}>
            <CourseUnitsHeader onUnitSelect={this.onUnitSelect} selectedIndex={this.state.selectedUnitIndex} />
            <div className={styles.SELData}>
              <div className={styles.title}> Book </div>
              <div className={styles.data}>{this.props.studentData.Book[this.state.selectedUnitIndex]}</div>
            </div>

            <div className={styles.SELData}>
              <div className={styles.title}> Quest </div>
              <div className={styles.data}>{this.props.studentData.Book[this.state.selectedUnitIndex]}</div>
            </div>

            <div className={styles.SELData}>
              <div className={styles.title}> Mini Game </div>
              <div className={styles.data}>{this.props.studentData.Book[this.state.selectedUnitIndex]}</div>
            </div>

            <div className={styles.SELData}>
              <div className={styles.title}> Read Aloud </div>
              <div className={styles.data}>{this.props.studentData.Book[this.state.selectedUnitIndex]}</div>
            </div>

            <div className={styles.SELData}>
              <div className={styles.title}> Check-ins </div>
              <div className={styles.data}>{this.props.studentData.Book[this.state.selectedUnitIndex]}</div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

interface Props {
  studentData: {
    studentName: string[];
    email: string;
    bookOpened: number;
    bookCompleted: number;
    berriesNum: number;
    loginTime: number;
    questFinished: number[];
    Book: string[];
    Quest: string[];
    MiniGame: string[];
    ReadAloud: string[];
    CheckIn: string[];
  };
}

class StudentProfile extends Component<Props> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    const studentData = {
      studentName: ['Jack Duan', '/images/student1.png'],
      email: 'jack@peekapak.com',
      bookOpened: 26,
      bookCompleted: 10,
      berriesNum: 11,
      loginTime: 8,
      questFinished: [9, 20],
      Book: ['20m', '3m', '8m', '9m', '12m', '2m', '6m', '8m', '3m', '11m'],
      Quest: ['20m', '3m', '8m', '9m', '12m', '2m', '6m', '8m', '3m', '11m'],
      MiniGame: ['20m', '3m', '8m', '9m', '12m', '2m', '6m', '8m', '3m', '11m'],
      ReadAloud: ['20m', '3m', '8m', '9m', '12m', '2m', '6m', '8m', '3m', '11m'],
      CheckIn: ['20m', '3m', '8m', '9m', '12m', '2m', '6m', '8m', '3m', '11m'],
    };

    return (
      <div className={`${styles.StudentProfile} ${utilityStyles.clearfix}`}>
        <VerticalSpacer ems={2} />
        <div className={styles.KidBoard}>
          <div className={styles.StudentInfo}>
            <img alt='Initials' src={studentData.studentName[1]} />
            <div className={styles.Name}> {studentData.studentName[0]}</div>
            <div className={styles.Email}> {studentData.email} </div>

            <div className={styles.studentStatistics}>
              <div className={styles.dataValue}>{studentData.bookOpened}</div>

              <div className={styles.dataType}>Book Opened</div>
            </div>

            <div className={styles.studentStatistics}>
              <div className={styles.dataValue}>{studentData.bookCompleted}</div>

              <div className={styles.dataType}>Book Completed</div>
            </div>

            <div className={styles.studentStatistics}>
              <div className={styles.dataValue}>
                {studentData.berriesNum}
                <img alt='Berries' src={berryGraphic} style={{ width: '30px', margin: '0px', height: '30px' }} />
              </div>

              <div className={styles.dataType}>Berries</div>
            </div>

            <div className={styles.studentStatistics}>
              <div className={styles.dataValue}>
                {studentData.questFinished[0]}/{studentData.questFinished[1]}
              </div>

              <div className={styles.dataType}>Quest Finished</div>
            </div>
          </div>

          <KidProfileBody studentData={studentData} />
        </div>
      </div>
    );
  }
}

export default StudentProfile;
